import { useMutation, useQueryClient } from '@tanstack/react-query'

import chatService from '../services'
import { chatKeys } from '../../keys'
import { ChatMessageListResponse } from '../../sse'

type MarkAsReadInfiniteData = {
	pages: ChatMessageListResponse[]
	pageParams: (string | undefined)[]
}

// Version that accepts roomId as mutation parameter (for use in lists)
export function useMutationMarkRoomAsRead() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (roomId: string) => chatService.markAsRead(roomId),
		onSuccess: (_, roomId) => {
			queryClient.setQueriesData<MarkAsReadInfiniteData>(
				{ queryKey: chatKeys.messages(roomId) },
				(old) => {
					if (!old) return old

					return {
						...old,
						pages: old.pages.map((page) => ({
							...page,
							items: page.items
								.filter((item) => !item.id.startsWith('unread-divider'))
								.map((item) => ({ ...item, isRead: true })),
						})),
					}
				},
			)
		},
	})
}
